export function Home() {
  return (
    <div>there will be buttons here to take you to he different pages</div>
  );
}
